import { T_KeyValue } from "@/types/app.type";

export const size = {
  xl: "!py-[20px] px-7 !text-[21px] leading-[27px]",
  l: "!py-[12px] !px-4 text-[16px] leading-[24px]",
  m: "!py-[8px] !px-2 text-[16px] leading-[24px]",
  s: "!py-[4px] !px-[12px] !text-[12px] leading-[16px]",
};

export const iconSize: T_KeyValue = {
  l: "p-1.5",
  m: "p-1",
  s: "p-1"
};

export const focusVisible:  { [key: string]: string } = {
  primary:
    "focus-visible:after:-z-10 focus-visible:after:h-[calc(100%+4px)] focus-visible:after:w-[calc(100%+4px)] focus-visible:after:rounded-8 focus-visible:after:shadow-button focus-visible:after:absolute",
  secondary:
    "focus-visible:after:-z-10 focus-visible:after:h-[calc(100%+8px)] focus-visible:after:w-[calc(100%+8px)] focus-visible:after:rounded-8 focus-visible:after:shadow-button focus-visible:after:absolute",
  ghost:
    "focus-visible:after:-z-10 focus-visible:after:h-[calc(100%+4px)] focus-visible:after:w-[calc(100%+4px)] focus-visible:after:rounded-8 focus-visible:after:shadow-button focus-visible:after:absolute"
};

export const lightAppearance: { [key: string]: string[] } = {
  primary: ["bg-interactive-50", "disabled:bg-interactive-50"],
  secondary: [],
  ghost: []
};

export const variant: {[key: string]: string[]} = {
  "primary": [
    "bg-button-primary-bg", "text-button-primary-color",
    "!hover:bg-button-primary-hover-bg hover:text-button-primary-hover-color",
    "focus-visible:outline-interactive-yellow focus-visible:outline-2 focus-visible:outline-offset-2",
    "disabled:bg-interactive-yellow disabled:opacity-30"
  ],
  "secondary": [
    "bg-button-secondary-bg border border-interactive-black text-interactive-black",
    "!hover:bg-button-secondary-hover-bg hover:text-button-secondary-hover-color",
    "focus-visible:outline-interactive-black focus-visible:outline-2 focus-visible:outline-offset-2",
    "disabled:bg-transparent disabled:border-interactive-black disabled:text-interactive-black disabled:opacity-30"
  ],
  "ghost": [
    "bg-button-ghost-bg text-interactive-black",
    "hover:font-bold hover:decoration-2 hover:decoration-interactive-black hover:underline hover:underline-offset-4",
    "focus-visible:outline-interactive-black focus-visible:outline-2 focus-visible:outline-offset-2",
    "disabled:bg-transparent disabled:decoration-2 disabled:text-interactive-black disabled:no-underline disabled:opacity-30"
  ],
  "link": [
    "!bg-transparent", "!text-button-link-color",
    "!hover:bg-transparent !hover:text-button-link-hover-color",
    "focus-visible:outline-interactive-yellow focus-visible:outline-0 focus-visible:outline-offset-0",
    "disabled:bg-interactive-yellow disabled:opacity-30"
  ],
};

export const textButtonColor: { [key: string]: string } = {
  primary: "text-base-0",
  secondary: "text-black group-disabled:text-interactive-100",
  ghost:
    "text-black group-hover:text-interactive-700 group-disabled:text-interactive-100"
};

export const iconColorLightApperance: { [key: string]: string | string[] } = {
  primary:
    "fill-interactive-black group-hover:fill-base-0 group-disabled:fill-interactive-black",
  secondary: [],
  ghost: []
};

export const iconColor:  { [key: string]: string } = {
  primary: "group-hover:fill-base-white",
  secondary:
    "group-hover:fill-base-white group-disabled:fill-base-white",
  ghost:
    ""
};
